/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "internal": {
            "nested": {
              "message": {
                "nested": {
                  "DeleteDeviceCodesRequest": {
                    "fields": {
                      "deviceCodeIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "DeleteDeviceCodesResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.internal?.nested?.message?.nested?.DeleteDeviceCodesRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.internal?.nested?.message?.nested?.DeleteDeviceCodesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeleteDeviceCodesRequest @ squareup/devicesettings/internal/message/delete_device_codes.proto at 12:1
 */
export const DeleteDeviceCodesRequest = $root.lookupType('squareup.devicesettings.internal.message.DeleteDeviceCodesRequest');
fixType(DeleteDeviceCodesRequest);
Builder.createAndAttachToType(DeleteDeviceCodesRequest);
/**
 * SOURCE DeleteDeviceCodesResponse @ squareup/devicesettings/internal/message/delete_device_codes.proto at 16:1
 */
export const DeleteDeviceCodesResponse = $root.lookupType('squareup.devicesettings.internal.message.DeleteDeviceCodesResponse');
fixType(DeleteDeviceCodesResponse);
Builder.createAndAttachToType(DeleteDeviceCodesResponse);